import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "relative" };
import { onMounted, onUnmounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dropdown',
    props: {
        align: { default: 'right' },
        width: { default: '48' },
        contentClasses: { default: 'py-1 bg-white' }
    },
    setup(__props) {
        const props = __props;
        const closeOnEscape = (e) => {
            if (open.value && e.key === 'Escape') {
                open.value = false;
            }
        };
        onMounted(() => document.addEventListener('keydown', closeOnEscape));
        onUnmounted(() => document.removeEventListener('keydown', closeOnEscape));
        const open = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (open.value = !open.value))
                }, [
                    _renderSlot(_ctx.$slots, "trigger")
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: "fixed inset-0 z-40",
                    onClick: _cache[1] || (_cache[1] = ($event) => (open.value = false))
                }, null, 512), [
                    [_vShow, open.value]
                ]),
                _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-200",
                    "enter-from-class": "opacity-0 scale-95",
                    "enter-to-class": "opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "opacity-100 scale-100",
                    "leave-to-class": "opacity-0 scale-95"
                }, {
                    default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            class: "absolute z-50 mt-2 rounded-md shadow-lg",
                            style: { "display": "none" },
                            onClick: _cache[2] || (_cache[2] = ($event) => (open.value = false))
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["rounded-md ring-1 ring-black ring-opacity-5", __props.contentClasses])
                            }, [
                                _renderSlot(_ctx.$slots, "content")
                            ], 2)
                        ], 512), [
                            [_vShow, open.value]
                        ])
                    ]),
                    _: 3
                })
            ]));
        };
    }
});
